import Http from "./Http";

export class SessionsService extends Http {
  /**
   * Create users session
   * @param {Object} body
   * @param {string} body.email
   * @param {string} body.password
   */
  createSession(body) {
    return this.post("/sessions", body);
  }

  /**
   * Destroy users session, logout
   */
  destroySession({ accessToken }) {
    const axiosInstance = Http.createInstance({
      baseURL: `${import.meta.env.VITE_APP_BASE_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return axiosInstance.delete("/sessions");
  }
}

export default new SessionsService();
